import { AboutUsPage } from "./pages/AboutUsPage";
import { BrandPage } from "./pages/BrandPage";
import { ClosingPage } from "./pages/ClosingPage";
import { ContactPage } from "./pages/ContactPage";
import { CoverPage } from "./pages/CoverPage";
import { InvoicePages } from "./pages/InvoicePages";
import { OfferPage } from "./pages/OfferPage";
import { OptionPage } from "./pages/OptionPage";
import { PriceOfferPages } from "./pages/PriceOfferPages";
import { ArrangementPage, ProjectPage, ProjectTitlePage } from "./pages/ProjectPages";
import { DIVIDERS, SectionDivider } from "./pages/SectionDivider";
import { SuggestedArtworkPage } from "./pages/SuggestedArtworkPage";
import { TableOfContentsPage } from "./pages/TableOfContentsPage";
import { VisionMissionPage } from "./pages/VisionMissionPage";
import { WallsPage } from "./pages/WallsPage";
import { WorkflowPage } from "./pages/WorkflowPage";
/** Wraps a 1125 × 810 pt page so it can be scaled on screen and printed 1:1. */
function Shell({ children, anchor }) {
    return (<div className="page-shell" id={anchor}>
      <div className="page-scaler">{children}</div>
    </div>);
}
/**
 * Page order follows the reference proposal exactly:
 * 1 cover · 2 brand · 3 contents · 4–5 من نحن · 6 walls · 7–8 الرؤية والرسالة ·
 * 9–10 ما الذي نقدمه · 11–12 آلية العمل · 13–15 المشروع · 16–17 ترتيب اللوحات
 * المقترح · 18+ اللوحات المقترحة · عرض السعر · نضيف أفكارا · تواصل معنا.
 * (الصفحات 10، 14، 15، 16، 17 وصفحات «الخيار» من القالب العربي «ارتكا عربي.pdf»)
 */
const EMPTY_PROJECT = { name: "", description: "", photo: null, artType: "", artTypeDescription: "", arrangement: null };
// invoiceData: فاتورة المشروع/التسعيرة - صفحة السعر تطلع بنفس تصميم الفاتورة
// الأصلية بدل جدول القالب (العروض اليدوية تبقى على الجدول)
export function ProposalDocument({ data, invoiceData }) {
    const project = { ...EMPTY_PROJECT, ...data.project };
    // «الخيار N»: رقم صفحة الخيار بين صفحات الخيارات بس
    let optionCount = 0;
    return (<div className="proposal-document">
      <Shell anchor="page-cover"><CoverPage recipientName={data.recipientName} brandOffset={Number(data.coverBrandOffset) || 0}/></Shell>
      <Shell><BrandPage /></Shell>
      <Shell><TableOfContentsPage /></Shell>
      <Shell><SectionDivider spec={DIVIDERS.about}/></Shell>
      <Shell><AboutUsPage /></Shell>
      <Shell><WallsPage /></Shell>
      <Shell><SectionDivider spec={DIVIDERS.vision}/></Shell>
      <Shell><VisionMissionPage /></Shell>
      <Shell><SectionDivider spec={DIVIDERS.offer}/></Shell>
      <Shell><OfferPage /></Shell>
      <Shell><SectionDivider spec={DIVIDERS.workflow}/></Shell>
      <Shell><WorkflowPage /></Shell>
      <Shell anchor="page-project"><SectionDivider spec={DIVIDERS.project}/></Shell>
      <Shell><ProjectTitlePage project={project}/></Shell>
      <Shell><ProjectPage project={project}/></Shell>
      <Shell anchor="page-arrangement"><SectionDivider spec={DIVIDERS.arrangement}/></Shell>
      <Shell><ArrangementPage project={project}/></Shell>
      <Shell anchor="page-artworks"><SectionDivider spec={DIVIDERS.artworks}/></Shell>
      {data.artworks.map((page) => (<Shell key={page.id} anchor={`page-${page.id}`}>
          {page.layout === "option" ? <OptionPage page={page} number={++optionCount}/> : <SuggestedArtworkPage page={page}/>}
        </Shell>))}
      <Shell anchor="page-price"><SectionDivider spec={DIVIDERS.price}/></Shell>
      {invoiceData ? (<InvoicePages invoice={invoiceData} wrap={(node, key) => <Shell key={key}>{node}</Shell>}/>) : (<PriceOfferPages offer={data.price} wrap={(node, key) => <Shell key={key}>{node}</Shell>}/>)}
      <Shell><ClosingPage /></Shell>
      <Shell><SectionDivider spec={DIVIDERS.contact}/></Shell>
      <Shell><ContactPage /></Shell>
    </div>);
}
